import React from 'react';
import { motion } from 'framer-motion';
import { BoxIcon } from 'lucide-react';
export interface Feature {
  name: string;
  icon: BoxIcon;
}
export interface VenueCardProps {
  title: string;
  subtitle: string;
  capacity: string;
  description: string;
  image: string;
  features: Feature[];
  reverse?: boolean;
  index: number;
}
export function VenueCard({
  title,
  subtitle,
  capacity,
  description,
  image,
  features,
  reverse = false,
  index
}: VenueCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 40
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.7,
    delay: index * 0.1,
    ease: [0.16, 1, 0.3, 1]
  }} className={`flex flex-col ${reverse ? 'lg:flex-row-reverse' : 'lg:flex-row'} bg-h2o-800/50 backdrop-blur-sm border border-slate-700/50 rounded-lg overflow-hidden group hover:border-h2o-cyan/30 hover:shadow-[0_0_30px_rgba(6,182,212,0.1)] transition-all duration-500`} data-id="element-232">
      {/* Image Section (40%) */}
      <div className="w-full lg:w-[40%] h-64 lg:h-auto relative overflow-hidden" data-id="element-233">
        <div className="absolute inset-0 bg-h2o-950/20 group-hover:bg-transparent transition-colors duration-500 z-10" data-id="element-234" />
        <img src={image} alt={title} className="w-full h-full object-cover object-center transform group-hover:scale-105 transition-transform duration-700 ease-out" data-id="element-235" />
      </div>

      {/* Content Section (60%) */}
      <div className="w-full lg:w-[60%] p-8 lg:p-12 flex flex-col justify-center" data-id="element-236">
        <div className="mb-2 flex items-center justify-between flex-wrap gap-4" data-id="element-237">
          <span className="text-h2o-cyan font-medium tracking-wide text-sm uppercase" data-id="element-238">
            {subtitle}
          </span>
          <span className="bg-h2o-900/80 border border-slate-700 text-slate-300 text-xs px-3 py-1 rounded-full font-medium" data-id="element-239">
            {capacity}
          </span>
        </div>

        <h3 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-240">
          {title}
        </h3>

        <p className="text-slate-400 leading-relaxed mb-8 text-lg" data-id="element-241">
          {description}
        </p>

        <div className="mb-8" data-id="element-242">
          <h4 className="text-sm font-semibold text-slate-300 uppercase tracking-wider mb-4" data-id="element-243">
            Included Features
          </h4>
          <ul className="grid grid-cols-2 sm:grid-cols-3 gap-y-4 gap-x-2" data-id="element-244">
            {features.map((feature, idx) => {
            const Icon = feature.icon;
            return <li key={idx} className="flex items-center text-slate-400 text-sm" data-id="element-245">
                  <Icon className="w-4 h-4 mr-2 text-h2o-cyan-light" data-id="element-246" />
                  {feature.name}
                </li>;
          })}
          </ul>
        </div>

        <div className="mt-auto pt-4" data-id="element-247">
          <button className="bg-h2o-900 border border-h2o-cyan/50 text-h2o-cyan hover:bg-h2o-cyan hover:text-h2o-950 font-semibold px-6 py-3 rounded-lg transition-all duration-300 focus-visible-ring" data-id="element-248">
            Check Availability
          </button>
        </div>
      </div>
    </motion.div>;
}